import { render, staticRenderFns } from "./AppIconButton.vue?vue&type=template&id=3b0b61ae&scoped=true"
import script from "./AppIconButton.vue?vue&type=script&lang=js"
export * from "./AppIconButton.vue?vue&type=script&lang=js"
import style0 from "./AppIconButton.vue?vue&type=style&index=0&id=3b0b61ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0b61ae",
  null
  
)

export default component.exports